// Shared reviews data — used by both the home page ReviewsSection and the dedicated /reviews page.
const REVIEWS = [
    {
        name: "Danny G",
        date: "May 5, 2026",
        product: "The FlowLux Nebula — White",
        rating: 5,
        body: "Finished installing it. This thing is the greatest thing in the world. We recently lost power. The first thing I thought to plug into the generator was, not the internet, but the toilet's heated seats! lol 5 stars all day, just bought a second one yesterday. Yes it still functioned as a typical toilet without power.",
    },
    {
        name: "Mike H",
        date: "May 8, 2026",
        product: "The FlowLux Halo — White (×2)",
        rating: 5,
        body: "I ordered 2 and received after 10 days. I just installed them and we are very impressed with the quality. We are moving to the house next week. I will post after we use for a month or two. If everything goes well we'll order 3 more for another job.",
    },
    {
        name: "Cheryl S",
        date: "May 13, 2026",
        product: "The FlowLux Nova — White",
        rating: 5,
        body: "Love my smart toilet! I really did not think about the heated seat, but it is great. It took a day and a half to install. Everything worked great. It takes a while to understand and adjust all the features, but it is absolutely a great deal!",
    },
    {
        name: "Sarah G",
        date: "May 15, 2026",
        product: "The FlowLux Halo",
        rating: 5,
        body: "My husband spent 2 hours and got it installed today. Working well and we love it. I am going to order another one soon. Still need to learn how to adjust the temperature but so far so good!",
    },
    {
        name: "John M",
        date: "May 20, 2026",
        product: "The FlowLux Eclipse",
        rating: 5,
        body: "Awesome toilet! 2 weeks in I'm very impressed so far. I am handy so was able to install it myself and am happy with all the features. Way better than my regular toilet and definitely recommend the upgrade. There is no spare battery but not a big deal. Great toilet!",
    },
    {
        name: "Max L",
        date: "May 18, 2026",
        product: "The FlowLux Lunar",
        rating: 5,
        body: "Went for an upgrade to a wall-hung toilet and looks awesome so far. Love the look of it. Wish they had a smart wall-hung toilet but this one is great as well!",
    },
    {
        name: "John M",
        date: "May 23, 2026",
        product: "The FlowLux Pulsar",
        rating: 5,
        body: "Better than I expected! Honestly, it looks 10/10. I haven't tried it yet because I'm renovating the house, so I'll install it once the construction is finished. But overall, it looks to be of very good quality and comes with all the necessary accessories for installation. I recommend these, guys!",
    },
    {
        name: "Lary G",
        date: "May 21, 2026",
        product: "The FlowLux Pulsar",
        rating: 5,
        body: "omg this is hands down my best purchase. I have so many but this was so cool. the seat is warm. the lid closes on its own. no more surprises from my toddler when she forgets to flush it it does it for her.. this sale price is unbelievable compared to other stores.",
    },
    {
        name: "Steven A",
        date: "May 19, 2026",
        product: "The FlowLux Nebula",
        rating: 5,
        body: "Wanted to splurge on the bathroom and get a nicer toilet and came across FlowLux. A lot of other guys are charging 4-5k+ for similar style so went with FlowLux. Booked an installation with them too and they showed up and got the job done in just under 3 hours. Very impressed overall, highly rec to everyone.",
    },
    // ── 11 NEW reviews to reach 20 total ──
    {
        name: "Tasha B",
        date: "May 26, 2026",
        product: "The FlowLux Pulsar",
        rating: 5,
        body: "I love this! This was defiantly worth the impulse buy will definitely be buying more!",
    },
    {
        name: "Carlos R",
        date: "May 24, 2026",
        product: "The FlowLux Halo",
        rating: 5,
        body: "Best upgrade. Period.",
    },
    {
        name: "Jenna P",
        date: "May 28, 2026",
        product: "The FlowLux Halo",
        rating: 5,
        body: "Florida winters aren't really winters but my bathroom tile gets freezing in the morning. That heated seat at 5:30am before work has genuinely changed my mood for the day. Auto-open as I walk in still feels like a hotel every single time. Husband was skeptical, now he's already asking when we replace the guest bath. 10/10 from a very happy and slightly warmer person.",
    },
    {
        name: "Marcus T",
        date: "May 22, 2026",
        product: "The FlowLux Solaris",
        rating: 4,
        body: "The gold finish is absolutely stunning in person the pictures don't do it justice. Centerpiece of the whole bathroom now. Only knocking off a star because the remote took me a couple of days to figure out. Might need a tutorial for others. Once I got it dialed in, no complaints. Worth every penny for the look alone.",
    },
    {
        name: "Priya N",
        date: "May 29, 2026",
        product: "The FlowLux Aura",
        rating: 4,
        body: "Wanted to try the bidet experience without committing to a full smart toilet replacement. Aura was the perfect entry point. Installed in 25 minutes, my husband did it watching one YouTube video. Warm water wash is incredible. Only thing I wish was a wireless remote instead of the side panel. Still, for the price, it's a no-brainer.",
    },
    {
        name: "Rob K",
        date: "May 25, 2026",
        product: "The FlowLux Arc — Black",
        rating: 5,
        body: "Sleek, simple, works.",
    },
    {
        name: "Andrea L",
        date: "May 27, 2026",
        product: "The FlowLux Eclipse",
        rating: 5,
        body: "We've been remodeling our master bath for 8 months and I obsessed over the toilet choice for weeks. Value for the price is unreal. Booked their install service because plumbing was already torn up. The crew was on time, clean, polite, walked me through every feature before they left. Three weeks in and the auto-open lid still makes my mother-in-law laugh every time she visits. Worth every dollar.",
    },
    {
        name: "Diego V",
        date: "May 30, 2026",
        product: "The FlowLux Stella — Matte Black",
        rating: 4,
        body: "Matte black looks even better in person than online. Slight color difference vs the photos in certain lighting, slightly cooler tone, but honestly looks great in my bathroom. Installation was straightforward. Solid build, no wobble. Would buy again.",
    },
    {
        name: "Whitney F",
        date: "Jun 1, 2026",
        product: "The FlowLux Netto",
        rating: 5,
        body: "Cheaper than dinner out and it changed my bathroom forever.",
    },
    {
        name: "Eliot B",
        date: "May 31, 2026",
        product: "The FlowLux Nova",
        rating: 5,
        body: "My parents flew in from out of state for two weeks and my dad sat down once and asked me where I bought it. He went home and ordered one the same week. The dual seat wash settings made it genuinely useful for everyone in the house. Quiet, fast warm-up, and the night light is a nice touch when my kids stumble in at 3am. Easy 5 stars.",
    },
    {
        name: "Ines A",
        date: "Jun 2, 2026",
        product: "The FlowLux Lunar — Wall Hung",
        rating: 5,
        body: "The wall-hung look completely transformed the powder room. Modern, floating, easy to clean underneath. Friends keep asking where it's from.",
    },
    {
        name: "Brandon K",
        date: "Jun 4, 2026",
        product: "The FlowLux Eclipse",
        rating: 5,
        body: "Bought the Eclipse for the matte black look and it absolutely steals the show in our new powder room. Lid opens before I even reach the door. The dual-flush is whisper quiet and my wife who hates loud bathroom sounds is shocked. Delivery to Coral Gables took 4 business days. 0 issues for far!",
    },
];

export default REVIEWS;
